<div class="col-12 d-flex flex-column flex-md-row main-container p-md-0 p-4">

    <div class="d-md-none d-flex justify-content-start align-items-start px-4  logo-position">
        <img src="../../../assets/logo/Odda-LightMode.svg" alt="Centered Image" class="ps-xl-5 ps-lg-0 mt-2 img-fluid  "
            style="width: 48% !important;" />
    </div>

    <div class="col-xl-6 col-lg-6 col-md-6 col-12 d-flex flex-column align-items-center justify-content-between p-2 img-container"
        style="background-color: #D5E2F1;">
        <div class="d-md-flex d-none justify-content-start align-items-start p-4 w-100">
            <img src="../../../assets/logo/Odda-LightMode.svg" alt="Left Aligned Image mt-2"
                class="ps-xl-5 ps-lg-0 img-fluid" style="max-height: 100%;" />
        </div>
        <img src="../../../assets/gifs/sameday/sign-in.gif" alt="Centered Image" class="img-fluid mt-5 mt-md-2" />
    </div>

    <div
        class="col-xl-6 col-lg-6 col-md-6 col-12 d-flex flex-column justify-content-center align-items-center p-md-4 px-0 py-4">

        <div
            class="col-xxl-8 col-xl-10 col-lg-12 col-12 d-flex flex-column justify-content-center align-items-start p-md-4 p-0 gap-2">

            <div *ngIf="!submitted"
                class="d-flex flex-column justify-content-start align-items-start gap-md-3 gap-1  pb-5">
                <h1 class="text-primary fw-semibold mb-0 p-0"
                    style="text-align: left !important; font-size: clamp(24px,3vw,42px) !important;">Tech Driven
                    Deliveries</h1>
                <p class="m-0 p-0 text-muted"
                    style="text-align: left !important; font-size: clamp(12px,1.8vw,20px) !important;">Secure Login for
                    Seamless
                    Operations</p>
            </div>

            <p *ngIf="!submitted" class="  fw-medium p-1 m-1" style="font-size: clamp(16px,1.2vw,24px) !important;">
                Log In / Sign Up
            </p>

            <div *ngIf="!submitted" class="toggle-container">
                <input style="background-color: var(--input-color) !important" type="checkbox" id="loginToggle"
                    class="toggle-checkbox" (change)="toggleLoginMethod()" [checked]="!loginViaEmail" />
                <label for="loginToggle" class="toggle-label">
                    <span class="toggle-option">Log in via Email</span>
                    <span class="toggle-option">Log in via Phone</span>
                </label>
            </div>

            <div *ngIf="loginViaEmail && !submitted"
                class="mb-3 pt-3 pb-2 d-flex flex-column align-items-start justify-content-start"
                style="width: 100% !important;">
                <label for="email" class="form-label text-start">Enter Your
                    Email</label>

                <input type="email" class="form-control email" [(ngModel)]="email" id="email"
                    placeholder="hello@odda.co.uk" (input)="emailChanged()" aria-describedby="emailHelp"
                    style="width: 100% !important; background-color: var(--input-color-alt) !important"
                    (keyup.enter)="onSubmit()" />

                <div *ngIf="emailError" class=" text-start mt-2">
                    <p [innerHTML]="emailError" style="color: var(--error-text) !important;" class="text-start "></p>
                </div>
            </div>

            <div *ngIf="!loginViaEmail && !submitted" class=" pt-3 pb-2 d-flex flex-column col-12  ">
                <label for="email" class="form-label text-start">Enter Your
                    Phone Number</label>
                <div class="d-flex flex-row">
                    <form #f="ngForm" class="col-12" [formGroup]="phoneForm">
                        <div class="wrapper">
                            <ngx-intl-tel-input [cssClass]="'custom'" [preferredCountries]="preferredCountries"
                                [enableAutoCountrySelect]="true" [customPlaceholder]="numberPlaceholder"
                                [enablePlaceholder]="true" [searchCountryFlag]="true" [searchCountryField]="[
                              SearchCountryField.Iso2,
                              SearchCountryField.Name
                            ]" [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.UnitedKingdom"
                                [maxLength]="15" [phoneValidation]="true" [separateDialCode]=true
                                [numberFormat]="PhoneNumberFormat.International" name="phone" formControlName="phone"
                                (keyup.enter)="onSubmit()" (keypress)="onKeyPress($event)">
                            </ngx-intl-tel-input>
                        </div>
                        <div *ngIf="!loader && emailError" class="text-start mt-1">
                            <p [innerHTML]="emailError" style="color: var(--error-text) !important;"
                                class="text-start "></p>
                        </div>
                    </form>
                </div>

            </div>


            <div *ngIf="!submitted" class="py-md-5 py-1 w-100">
                <button class="btn btn-primary mt-md-3 m-0 login-buttons" (click)="onSubmit()"
                    style="font-size: 16px !important;" type="submit">Log In</button>
            </div>



            <div *ngIf="!submitted" class="py-3 d-flex flex-row justify-content-center align-items-center w-100">
                <p class="p-0 m-0" style="font-size: 14px !important;">Not registered? <span class="text-primary"
                        style="font-size: 16px !important; text-decoration: underline; cursor: pointer !important;"
                        routerLink="/register">
                        Sign Up</span></p>
            </div>


            <div *ngIf="!submitted" class="py-3 d-flex flex-row justify-content-center align-items-center w-100">
                <p class="p-0 m-0 text-muted" style="font-size: 14px !important; ">By signing up you
                    agree to the terms
                    and
                    conditions
                </p>
            </div>


            <div *ngIf="submitted && !OTPsuccess"
                class="col-12   d-flex flex-column align-items-center justify-content-center pe-lg-2 me-lg-3">

                <p (click)="goBack()" class="fw-medium back-button d-flex align-items-center py-3" id="back" style="cursor: pointer; width: 280px !important;
    text-align: left !important; align-self: start;">
                    <i class="bi bi-chevron-left fw-bolder h2-icon me-2" style="text-decoration: none !important;"></i>
                    {{ loginViaEmail ? 'Go back to phone login' : 'Go back to email login' }}
                </p>

                <h2 class="text-start fs-4 mt-2 pt-2 fw-medium">
                    Enter OTP
                </h2>

                <p class="py-2 text-start w-100 text-center">
                    Please enter the <span class="fw-semibold">6 digit code</span>
                    sent to <br>
                    <span class="fw-semibold">{{email}}</span>
                </p>

                <ng-otp-input (onInputChange)="onOtpChange($event)" (keyup.enter)="onSubmit(true)"
                    [config]="{length:6, allowNumbersOnly:true}" style="color: black !important;"></ng-otp-input>

                <div class="py-3" style="width: 92%;">

                    <p class="text-danger fw-semibold" style="font-size: 14px; " *ngIf="invalidOTP"> Invalid OTP Entered
                    </p>
                    <div style="font-size: 13px;" class="d-flex justify-content-center">
                        Wait for
                        <span class="d-flex justify-content-start ms-1" style="min-width: 33px;">
                            {{ minutes }}:{{ seconds < 10 ? '0' + seconds : seconds }} </span>
                                <span *ngIf="minutes === 0 && seconds === 0" style="cursor: pointer;">
                                    <a class="text-primary fw-semibold"
                                        style="text-decoration: underline; font-size: 13px;"
                                        (click)="resendCode()">Resend</a>
                                </span>
                    </div>
                </div>


                <div class="py-1" style="width: 92%;">
                    <button class="btn btn-primary mt-3 login-buttons" (click)="onSubmit(true)"
                        style="font-size: 16px !important;" type="submit">Verify</button>
                </div>

            </div>

            <div *ngIf="OTPsuccess">
                <div class="py-3 d-flex flex-column justify-content-center align-items-center w-10 scrollable">
                    <p class="pb-2 mb-2 px-0 pt-0 mx-0 mt-0 text-success"
                        style="font-size: 14px !important; text-align: left !important;">We found following
                        organisations
                        linked with your Email. <br /> Select the Organisation you want to continue with.</p>

                    <div *ngIf="orgArray.length > 6" class="organization-search">
                        <label for="organizationSearch" class="visually-hidden">Search organisations</label>
                        <i class="bi bi-search organization-search-icon" aria-hidden="true"></i>
                        <input id="organizationSearch" type="search" class="form-control organization-search-input"
                            [(ngModel)]="organizationSearchTerm" (input)="filterOrganizations()"
                            placeholder="Search by name, code, or address" autocomplete="off"
                            aria-label="Search organisations" />
                        <button *ngIf="organizationSearchTerm" type="button" class="organization-search-clear"
                            (click)="clearOrganizationSearch()" aria-label="Clear organisation search">
                            <i class="bi bi-x-circle-fill" aria-hidden="true"></i>
                        </button>
                    </div>

                    <div class="py-3 d-flex flex-column" style="max-height: 70vh !important;overflow-y: auto;">
                        <div class="px-2 py-1 card border-0 shadow-sm mb-3 orgCard w-100 " [class.pointer-none]="loader"
                            style="cursor: pointer !important;" *ngFor="let org of filteredOrgArray, let i = index"
                            (click)="!loader && loginUsingOrg(org)">
                            <div class="row g-0 align-items-center">
                                <div class="col-auto">
                                    <div class="icon-circle  d-flex justify-content-center align-items-center"
                                        style="width: 60px; height: 60px; border-radius: 50%; background-color: var(--dialog-bg);">
                                        <i class="bi bi-buildings fs-3 text-secondary"></i>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="card-body">
                                        <h5 class="card-title mb-1"
                                            style="text-align: left !important; color: var(--txtDark); font-size: clamp(10px,1.8vw,14px) !important; font-weight: 500 !important;"
                                            *ngIf="org.orgName">{{org.orgName}}</h5>
                                        <h5 class="card-title mb-1"
                                            style="text-align: left !important; color: var(--txtDark); font-size: clamp(10px,1.8vw,14px) !important; font-weight: 500 !important;"
                                            *ngIf="!org.orgName && org.orgCode">{{org.orgCode}}</h5>

                                        <p class="card-text text-muted" style="text-align: left !important;">
                                            {{org.address}}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="filteredOrgArray.length === 0"
                            class="organization-search-empty text-center px-3 py-4" role="status">
                            <i class="bi bi-search fs-3" aria-hidden="true"></i>
                            <p class="mb-1 mt-2 fw-medium">No organisations found</p>
                            <p class="mb-0 text-muted">Try a different name, code, or address.</p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
